import Modal from "../modal/Modal";
import PositionForm from "../../containers/positions/PositionForm";
import { Button } from "../buttons";

function UpdatePositionModal({
  openModal,
  setOpenModal,
  positionForm,
  setPositionForm,
  submitHandler,
  errors,
  features,
  children,
  buttonId,
}) {
  return (
    <Modal dismissible show={openModal} onClose={() => setOpenModal(false)}>
      <Modal.Header>職位を更新します</Modal.Header>
      <Modal.Body className="overflow-y-auto">
        {children}
        <PositionForm
          positionForm={positionForm}
          setPositionForm={setPositionForm}
          errors={errors}
          features={features}
        />
      </Modal.Body>
      <Modal.Footer className="w-full space-x-[32px] justify-center">
        <div className="w-1/2">
          <Button
            color="light"
            className="w-full"
            onClick={() => setOpenModal(false)}
          >
            閉じる
          </Button>
        </div>
        <div className="w-1/2">
          <Button
            color="primary"
            className="w-full"
            onClick={submitHandler}
            id={buttonId}
          >
            更新
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default UpdatePositionModal;
